import { ActivityIndicator, type ActivityIndicatorProps } from "react-native";

import { useTheme } from "~/styles/theme";

export function Spinner({ color, ...props }: ActivityIndicatorProps) {
  const { colors } = useTheme();
  return (
    <ActivityIndicator
      accessibilityLabel="Loading"
      color={color ?? colors.heading}
      {...props}
    />
  );
}
